import type { Action } from '../actions';
import type { UserCurrentReceived } from './user.action';
import type { UserState } from './user.model';
import { initialUserState } from './user.model';

export function userReducer(state: UserState = initialUserState, action: Action) {
  switch (action.type) {
    case 'USER_CURRENT_RECEIVED':
      return onUserInfoReceived(state, action);
    case 'USER_INFO_RECEIVED':
      const { permissions, icId } = action;
      return {
        ...state,
        permissions,
        icId,
      };
    default:
      return state;
  }
}

function onUserInfoReceived(state: UserState, { userInfo }: UserCurrentReceived): UserState {
  return {
    ...state,
    ...userInfo,
  };
}
